import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import WhatshotIcon from '@material-ui/icons/Whatshot';
import InfoIcon from '@material-ui/icons/Info';
import FaceIcon from '@material-ui/icons/Face';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
});

export default function LabelBottomNavigation() {
  const classes = useStyles();
  const [value, setValue] = React.useState('recents');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <BottomNavigation
      value={value}
      onChange={handleChange}
      className={classes.root}
    >
      <BottomNavigationAction
        component={Link}
        to="/profile"
        label="Profile"
        value="profile"
        icon={<FaceIcon />}
      />
      <BottomNavigationAction
        component={Link}
        to="/"
        label="Swipe"
        value="swipe"
        icon={<WhatshotIcon />}
      />
      <BottomNavigationAction
        component={Link}
        to="/about"
        label="About"
        value="about"
        icon={<InfoIcon />}
      />
    </BottomNavigation>
  );
}
